import {
  brandProfileConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { brandProfileService } from "../../services";
import { success, withSpinner } from "../../../../redux/actions/utilities";

const {
  FETCH_BRAND,
  GET_BRAND_LOCATIONS,
  FETCH_BRAND_PROFILE,
  FETCH_BRAND_RESTAURANT,
} = brandProfileConstants;

//Get the table data for brand profile
export const getBrandRestaurants = (brandId, queryString) => {
  return (dispatch) => {
    //Active spinner before the call
    withSpinner(dispatch, FETCH_BRAND_RESTAURANT, () =>
      brandProfileService
        .getBrandRestaurants(brandId, queryString)
        .then(
          (response) => {
            dispatch(success(response, FETCH_BRAND_RESTAURANT));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Get generic data for brand profile
export const getBrandProfile = (queryString) => {
  return (dispatch) => {
    brandProfileService.getBrandProfile(queryString).then(
      (response) => {
        dispatch(success(response, FETCH_BRAND_PROFILE));
      },
      (error) => {
        customToast(error[0], toastTypes.ERROR);
      }
    );
  };
};

//Get brand location by brand Id
export const getBrandLocationsByBrandId = (brandId) => {
  return (dispatch) => {
    //Active spinner before the call
    withSpinner(dispatch, GET_BRAND_LOCATIONS, () =>
      brandProfileService
        .getBrandLocationsByBrandId(brandId)
        .then(
          (response) => {
            dispatch(success(response, GET_BRAND_LOCATIONS));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Get generic data for brand
export const getBrandByBrandId = (brandId) => {
  return (dispatch) => {
    brandProfileService.getBrandByBrandId(brandId).then(
      (response) => {
        dispatch(success(response, FETCH_BRAND));
      },
      (error) => {
        customToast(error[0], toastTypes.ERROR);
      }
    );
  };
};

export const brandProfileActions = {
  getBrandRestaurants,
  getBrandProfile,
  getBrandLocationsByBrandId,
  getBrandByBrandId,
};
